import { FC, useRef, useState } from 'react';
import { BigNumber } from 'ethers';
import { useWeb3React } from '@web3-react/core';
import { Box, CircularProgress, Dialog, styled, Typography, useTheme } from '@mui/material';

import { useAppSelector } from 'state/hooks';
import { ConnectWallet, ContainedButton } from 'components/common/Button';
import { ContainedInput } from 'components/common/Input';
import ObjectCreator from 'components/common/Creator/ObjectCreator';

const ModalDialog = styled(Dialog)(() => ({
  '.MuiDialog-container > .MuiPaper-root': {
    borderRadius: '20px',
    maxWidth: '630px',
    width: '100%',
    background: '#2A3139',
    boxShadow:
      '0px 100px 77px rgba(0, 0, 0, 0.13), 0px 25.9935px 52.3711px rgba(0, 0, 0, 0.0989853), 0px 10.1608px 47.2956px rgba(0, 0, 0, 0.0902431), 0px 5.70356px 44.4605px rgba(0, 0, 0, 0.0829201), 0px 3.80638px 39.8596px rgba(0, 0, 0, 0.0717558), 0px 2.15748px 29.2214px rgba(0, 0, 0, 0.0505145)',
    padding: '15px 16px 20px',
  },
}));

// modal header
const ModalHeader = styled(Box)(() => ({}));

const ModalTitle = styled(Typography)(() => ({
  fontFamily: 'Prompt',
  fontStyle: 'normal',
  fontWeight: '700',
  fontSize: '19px',
  lineHeight: '29px',
  textAlign: 'center',
}));

// modal body
const ModalBody = styled(Box)(() => ({
  marginTop: '23px',
  marginBottom: '54px',
}));

const AvaialbleSection = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

const AvailableAmount = styled(Typography)(() => ({
  fontFamily: 'Prompt',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '21px',
  marginBottom: '8px',
}));

const AmountInput = styled(ContainedInput)(() => ({
  height: '27px',
}));

// modal footer
const ModalFooter = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  position: 'relative',
  textAlign: 'center',
  alignItems: 'center',
}));

const ActionButton = styled(ContainedButton)(() => ({
  maxWidth: '102px',
  height: '32px',
}));

interface Props {
  onClose: () => void;
}

const TutorialModal: FC<Props> = ({ onClose }) => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [amount, setAmount] = useState<string>('');
  const [amountInWei, setAmountInWei] = useState<BigNumber>(BigNumber.from(0));

  const { pendingTxHash } = useAppSelector((state) => state.modal);
  const pendingTxHashRef: { current: string | undefined } = useRef();
  pendingTxHashRef.current = pendingTxHash;

  const theme = useTheme();
  const { account } = useWeb3React();

  const handleClose = () => {
    onClose();
  };
  const getButtonText = () => {
    return 'Deposit';
  };

  // withdraw modal content
  return (
    <ModalDialog maxWidth="lg" onClose={handleClose} open theme={theme}>
      <ObjectCreator currentObjectData={[]} data={[]} href={[]} onClose={handleClose}/>
    </ModalDialog>
  );
};

export default TutorialModal;
